import {
  LucideBuilding,
  LucideHome,
  LucideSettings,
  LucideUsers,
  LucideBox,
  LucideBarChart,
  LucideShoppingCart,
  ReceiptText,
  Layers,
  LucideInfo,
  Globe,
  Handshake,
  IdCard,
  Briefcase,
  ShoppingBag,
  Calendar,
  Images,
  BarChart3,
  MessageSquare,
  Kanban,
  CalendarClock,
  Star,
  ListTree,
  Tag,
  Ruler,
  Warehouse,
  ClipboardList,
  PackagePlus,
  ArrowLeftRight,
  Truck,
  Receipt,
  Building2,
  Shield,
  CreditCard,
  Bell,
  Activity,
  User,
  Lock,
  UserPlus,
} from "lucide-react";

export const ADMIN_MENU_CONFIG: any = {
  dashboard: {
    label: "Dashboard",
    path: "/admin/dashboard",
    icon: LucideHome,
  },
  tenants: {
    label: "Tenants",
    icon: LucideBuilding,
    path: "/admin/tenant/list",
    // Creation now happens via a modal on the list page itself, not a
    // separate route — a tenant's own detail/edit page falls under this
    // prefix too, so it still activates the group while you're inside one.
    matchPaths: ["/admin/tenant"],
  },
  transactions: {
    label: "Transactions",
    icon: ReceiptText,
    path: "/admin/transaction/list",
    // Creation now happens via a modal on the list page itself.
    matchPaths: ["/admin/transaction"],
  },
  plans: {
    label: "Plans",
    icon: Layers,
    path: "/admin/plans/list",
    // Creation now happens via a modal on the list page itself.
    matchPaths: ["/admin/plans"],
  },
  reports: {
    label: "Reports",
    path: "/admin/reports",
    icon: LucideBarChart,
  },
  support: {
    label: "Support",
    icon: LucideInfo,
    subMenu: [
      { label: "Signup Request", icon: UserPlus, path: "/admin/signup-requests" },
      { label: "Support Request", icon: MessageSquare, path: "/admin/support" },
    ],
  },
  settings: {
    label: "Settings",
    icon: LucideSettings,
    subMenu: [
      { label: "Profile", icon: User, path: "/admin/settings/profile" },
      { label: "Password", icon: Lock, path: "/admin/settings/password" },
      { label: "Notifications", icon: Bell, path: "/admin/notifications" },
    ],
  },
};

export const MENU_CONFIG: any = {
  dashboard: {
    label: "Dashboard",
    path: "/app/dashboard",
    icon: LucideHome,
    module: "dashboard",
    permission: "view",
  },
  businessProfile: {
    label: "Business Profile",
    icon: Globe,
    subMenu: [
      { label: "Overview", icon: IdCard, comingSoon: true },
      { label: "Services", icon: Briefcase, comingSoon: true },
      { label: "Products", icon: ShoppingBag, comingSoon: true },
      { label: "Events", icon: Calendar, comingSoon: true },
      { label: "Gallery", icon: Images, comingSoon: true },
      { label: "Analytics", icon: BarChart3, comingSoon: true },
    ],
  },
  crm: {
    label: "CRM",
    icon: Handshake,
    subMenu: [
      { label: "Leads", icon: MessageSquare, comingSoon: true },
      { label: "Pipeline", icon: Kanban, comingSoon: true },
      { label: "Appointments", icon: CalendarClock, comingSoon: true },
      { label: "Reviews", icon: Star, comingSoon: true },
    ],
  },
  inventory: {
    label: "Inventory",
    icon: LucideBox,
    subMenu: [
      {
        label: "Products",
        icon: LucideBox,
        path: "/app/product/list",
        matchPaths: ["/app/product"],
        module: "products",
        permission: "view",
      },
      {
        label: "Categories",
        icon: ListTree,
        path: "/app/category",
        module: "categories",
        permission: "view",
      },
      {
        label: "Brands",
        icon: Tag,
        path: "/app/brand",
        module: "brands",
        permission: "view",
      },
      {
        label: "Units",
        icon: Ruler,
        path: "/app/unit",
        module: "units",
        permission: "view",
      },
      {
        label: "Warehouses",
        icon: Warehouse,
        path: "/app/warehouse",
        module: "warehouses",
        permission: "view",
      },
      {
        label: "Stock Levels",
        icon: ClipboardList,
        path: "/app/stock/levels",
        module: "stockLevels",
        permission: "view",
      },
      {
        label: "Stock Adjustment",
        icon: PackagePlus,
        path: "/app/stock/adjust",
        module: "stockAdjustment",
        permission: "view",
      },
      {
        label: "Stock Movements",
        icon: ArrowLeftRight,
        path: "/app/stock/movements",
        module: "stockMovements",
        permission: "view",
      },
      {
        label: "Transfers",
        icon: Truck,
        path: "/app/stock/transfers",
        matchPaths: ["/app/stock/transfers"],
        module: "transfers",
        permission: "view",
      },
    ],
  },
  sales: {
    label: "Sales",
    icon: Receipt,
    subMenu: [
      {
        label: "Sales Orders",
        icon: Receipt,
        path: "/app/sale/list",
        matchPaths: ["/app/sale"],
        module: "sales",
        permission: "view",
      },
      {
        label: "Customers",
        icon: LucideUsers,
        path: "/app/customer/list",
        module: "customers",
        permission: "view",
      },
    ],
  },
  purchases: {
    label: "Purchases",
    icon: LucideShoppingCart,
    subMenu: [
      {
        label: "Purchases",
        icon: LucideShoppingCart,
        path: "/app/purchase/list",
        matchPaths: ["/app/purchase"],
        module: "purchases",
        permission: "view",
      },
      {
        label: "Suppliers",
        icon: Building2,
        path: "/app/supplier/list",
        module: "suppliers",
        permission: "view",
      },
    ],
  },
  reports: {
    label: "Reports",
    path: "/app/reports",
    icon: LucideBarChart,
    // There's no single "can see the Reports page" permission — the menu
    // item shows up as soon as a role can view at least one report type.
    module: [
      "reportsSales",
      "reportsPurchase",
      "reportsStock",
      "reportsProfit",
      "reportsInventoryValuation",
      "reportsTransfer",
    ],
    permission: "view",
  },
  team: {
    label: "Team",
    icon: LucideUsers,
    subMenu: [
      {
        label: "Staff",
        icon: IdCard,
        path: "/app/team-management/user-list",
        matchPaths: ["/app/team-management/user"],
        module: "users",
        permission: "view",
      },
      {
        label: "Designations",
        icon: Shield,
        path: "/app/team-management/role-list",
        matchPaths: ["/app/team-management/role"],
        module: "users",
        permission: "view",
      },
      {
        label: "Departments",
        icon: Building2,
        path: "/app/team-management/department-list",
        module: "users",
        permission: "view",
      },
    ],
  },
  settings: {
    label: "Settings",
    icon: LucideSettings,
    subMenu: [
      { label: "Profile", icon: User, path: "/app/settings/profile" },
      {
        label: "Organization",
        icon: Building2,
        path: "/app/settings/organization",
      },
      { label: "Password", icon: Lock, path: "/app/settings/password" },
      {
        label: "Notifications",
        icon: Bell,
        path: "/app/settings/notifications",
      },
      {
        label: "Billing",
        icon: CreditCard,
        path: "/app/settings/billing",
        adminOnly: true,
      },
      {
        label: "Usage",
        icon: Activity,
        path: "/app/settings/usage",
        adminOnly: true,
      },
    ],
  },
  support: {
    label: "Support",
    path: "/app/support",
    icon: LucideInfo,
  },
};
